export class PuzzlePiece extends Phaser.GameObjects.Image {
    id: number;
    currentPosition: Phaser.Math.Vector2;
    correctPosition: Phaser.Math.Vector2;
    enabled: boolean;
    correctSlotId: number;

    constructor(scene: Phaser.Scene, x: number, y: number, frame: string, id: number, currentPosition: Phaser.Math.Vector2, correctPosition: Phaser.Math.Vector2) {
        super(scene, x, y, "assets", frame);
        this.id = id;
        this.currentPosition = currentPosition;
        this.correctPosition = correctPosition;
        this.enabled = true;

        this.setInteractive();
        scene.input.setDraggable(this);
        scene.add.existing(this);
    }
}



// WEBPACK FOOTER //
// ./src/games/JigsawPuzzleGame/objects/PuzzlePiece.ts